<template>
  <v-container fluid>
    <form>
      <v-row>
        <v-col cols="12" md="12">
          <v-checkbox
              v-model="form.is_abroad"
              label="বর্তমান ঠিকানা হলে বাক্সে (✔) টিক দিন"
              density="comfortable"
              hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
              v-model="form.division"
              :items="divisions"
              label="বিভাগ *"
              placeholder="বিভাগ বাছাই করুন"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
              v-model="form.district"
              :items="districts"
              label="জেলা *"
              placeholder="জেলা বাছাই করুন"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
              v-model="form.police_station"
              :items="districts"
              label="থানা *"
              placeholder="থানা বাছাই করুন"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
              v-model="form.sub_district"
              :items="districts"
              label="উপজেলা *"
              placeholder="উপজেলা বাছাই করুন"
              variant="outlined"
              density="comfortable"
          ></v-select>
        </v-col>


        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.village_bn"
              label="গ্রাম/মহল্লা/ওয়ার্ড (বাংলা)"
              placeholder="গ্রাম/মহল্লা/ওয়ার্ড নাম বাংলায় লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.village_en"
              label="গ্রাম/মহল্লা/ওয়ার্ড (ইংরেজি)"
              placeholder="গ্রাম/মহল্লা/ওয়ার্ড নাম ইংরেজিতে লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.post_office_bn"
              label="পোস্ট অফিস (বাংলা)"
              placeholder="পোস্ট অফিস বাংলায় লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.post_office_en"
              label="পোস্ট অফিস (ইংরেজি)"
              placeholder="গপোস্ট অফিস ইংরেজিতে লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
              v-model="form.post_code"
              label="পোস্ট কোড"
              placeholder="পোস্ট কোড লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="form.house_number_bn"
              label="বাড়ি নম্বর (বাংলা)"
              placeholder="বাড়ি নম্বর বাংলায় লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="form.house_number_en"
              label="বাড়ি নম্বর (ইংরেজি)"
              placeholder="বাড়ি নম্বর ইংরেজিতে লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="form.road_number_bn"
              label="রাস্তা নম্বর (বাংলা)"
              placeholder="রাস্তা বাংলায় নম্বর লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="form.road_number_en"
              label="রাস্তা নম্বর (ইংরেজি)"
              placeholder="রাস্তা ইংরেজিতে নম্বর লিখুন"
              variant="outlined"
              density="comfortable"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
              color="primary"
              size="large"
              class="me-3 rounded-lg"
              type="submit"
          >
            <v-icon start> mdi-content-save-outline </v-icon>
            সংরক্ষণ করুন
          </v-btn>

          <v-btn
              color="grey-darken-1"
              variant="outlined"
              size="large"
              class="rounded-lg"
              @click="resetForm"
          >
            <v-icon start>mdi-refresh</v-icon>
            রিসেট
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>

export default {
  name: "PresentAddress",

  data() {
    return {
      districts: ["নওগাঁ", "ঢাকা", "রাজশাহী", "চট্টগ্রাম"],
      divisions: ["ঢাকা", "চট্টগ্রাম", "রাজশাহী", "খুলনা", "সিলেট", "বরিশাল", "রংপুর", "ময়মনসিংহ"],
      form: {
        is_abroad: false,
        division: null,
        district: null,
        police_station: null,
        sub_district: null,
        village_bn: "",
        village_en: "",
        post_office_bn: "",
        post_office_en: "",
        post_code: "",
        house_number_bn: "",
        house_number_en: "",
        road_number_bn: "",
        road_number_en: "",
      },
    };
  },

  methods: {
    resetForm() {
      this.form = {
        is_abroad: false,
        division: null,
        district: null,
        police_station: null,
        sub_district: null,
        village_bn: "",
        village_en: "",
        post_office_bn: "",
        post_office_en: "",
        post_code: "",
        house_number_bn: "",
        house_number_en: "",
        road_number_bn: "",
        road_number_en: "",
      };
    },
  },
};
</script>
